import { render, staticRenderFns } from "./referenceMessageInfoModal.vue?vue&type=template&id=5658d48d&scoped=true&"
import script from "./referenceMessageInfoModal.vue?vue&type=script&lang=js&"
export * from "./referenceMessageInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./referenceMessageInfoModal.vue?vue&type=style&index=0&id=5658d48d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5658d48d",
  null
  
)

export default component.exports